import * as THREE from 'heritage/assets/three.module.js';

// Retain the logo's leaf outlines. Open the narrow veins across their width
// so their negative space remains visible on a tilted, dimensional crown.
export function createCrownGeometry(original){
 const shape=original.clone();
 shape.holes=original.holes.map(hole=>hole.clone());
 let geometry=new THREE.ExtrudeGeometry(shape,{depth:.5,bevelEnabled:false,bevelThickness:.07,bevelSize:.045,bevelSegments:4,curveSegments:12,steps:1});
 geometry.translate(-40,-38.6219,-.25);geometry.scale(.039,-.039,.039);
 geometry=subdivideForBend(geometry);
 const pos=geometry.attributes.position; geometry.userData.flatPositions=pos.array.slice();
 geometry.computeVertexNormals();
 // Average coincident extrusion normals before wrapping the crown.
 const normal=geometry.attributes.normal,sums=new Map(),keys=[];
 for(let i=0;i<pos.count;i++){
  const key=[pos.getX(i),pos.getY(i),pos.getZ(i)].map(x=>Math.round(x*1e6)).join(',');
  keys.push(key);let n=sums.get(key);if(!n){n=new THREE.Vector3();sums.set(key,n);}
  n.x+=normal.getX(i);n.y+=normal.getY(i);n.z+=normal.getZ(i);
 }
 for(const n of sums.values())n.normalize();
 // Transport those normals through the continuous oval bend. Recomputing
 // from the large cap triangles would leave facets across each leaf.
 const jacobian=new THREE.Matrix3(),normalMatrix=new THREE.Matrix3(),n=new THREE.Vector3();
 for(let i=0;i<pos.count;i++){
  const x=pos.getX(i),y=pos.getY(i),z=pos.getZ(i),r=Math.hypot(x,y),s=x/r,c=y/r,a=1.18+z*1.4,b=1.48+z*1.4;
  jacobian.set(a*c*c/r,-a*s*c/r,1.4*s,1.1*s,1.1*c,0,-b*s*c/r,b*s*s/r,1.4*c);
  normalMatrix.copy(jacobian).invert().transpose();
  n.copy(sums.get(keys[i])).applyMatrix3(normalMatrix).normalize();
  normal.setXYZ(i,n.x,n.y,n.z);
  pos.setXYZ(i,a*s,(r-1.27)*1.1,b*c);
 }
 normal.needsUpdate=true;geometry.computeBoundingBox();geometry.computeBoundingSphere();
 geometry.userData.cutouts=shape.holes.length;
 return geometry;
}

// Small triangles follow the oval continuously instead of spanning it as
// flat chords, which can visually bridge the thin leaf openings.
function subdivideForBend(source){
 const points=source.attributes.position,out=[];
 const length2=(a,b)=>(a[0]-b[0])**2+(a[1]-b[1])**2+(a[2]-b[2])**2;
 const midpoint=(a,b)=>a.map((v,i)=>(v+b[i])*.5);
 function emit(a,b,c,depth=0){
  const ab=length2(a,b),bc=length2(b,c),ca=length2(c,a);
  if(Math.max(ab,bc,ca)<.01||depth===9){out.push(...a,...b,...c);return;}
  if(ab>=bc&&ab>=ca){const m=midpoint(a,b);emit(a,m,c,depth+1);emit(m,b,c,depth+1);}
  else if(bc>=ca){const m=midpoint(b,c);emit(a,b,m,depth+1);emit(a,m,c,depth+1);}
  else{const m=midpoint(c,a);emit(a,b,m,depth+1);emit(m,b,c,depth+1);}
 }
 const point=i=>[points.getX(i),points.getY(i),points.getZ(i)];
 for(let i=0;i<points.count;i+=3)emit(point(i),point(i+1),point(i+2));
 const geometry=new THREE.BufferGeometry();
 geometry.setAttribute('position',new THREE.Float32BufferAttribute(out,3));
 source.dispose();return geometry;
}